import React, { Component } from 'react'
import { CSSTransitionGroup } from 'react-transition-group'
import LogoEditor from './LogoEditor'
import LogoMockups from './LogoMockups'
import LogoCanvas from './LogoCanvas'
import i18n from '../i18n.json'
import MessengerChat from './MessengerChat'
import Swipeable from 'react-swipeable'

class LogoPreview extends Component {
  constructor(props) {
    super(props)
    this.state = {
      displayLogoEditor: true,
      displayLogoPreview: false,
      editedParams: []
    }
  }

  componentWillMount() {
    let { userPrefs } = this.props.newLogo

    if (userPrefs) {
      this.props.requestIcons(userPrefs)
      .then(availableIcons => {
        let _availableIcons = null
        this.setState({availableIcons: _availableIcons})

        return this.props.fetchLogoPreviews(this.props.newLogo)
        .then(res => {
          Promise.resolve(res)
        })
        .catch(error => {
          Promise.reject(error)
        })
      })
      .catch(error => {
        // console.log('error', error)
      })
   }
  }

  renderLogoCanvas(currentLogoPreview) {
    let { availableLogoPreviews, availableIcons, availableColorPalettes } = this.props.newLogo

    if (!availableLogoPreviews) return
    if (!availableLogoPreviews.payload) return
    let logoPreviews = availableLogoPreviews.payload
    if (logoPreviews.length < currentLogoPreview) return
    let data = logoPreviews[currentLogoPreview]
    if (!data) return

    let currentColorPalette = availableColorPalettes.find(color => color.uid === data.colorPalette.uid)

    let _availableIcons = []
    if (availableIcons) {
      if (availableIcons.payload) {
        if (availableIcons.payload.length) {
          _availableIcons = availableIcons.payload
        }
      }
    }
    let asset = null
    if ((data.layoutProcedure.name === 'generativeLayout005') ||
        (data.layoutProcedure.name === 'generativeLayout006') ||
        (data.layoutProcedure.name === 'generativeLayout0061') ||
        (data.layoutProcedure.name === 'generativeLayout009') ||
        (data.layoutProcedure.name === 'generativeLayout007')) {
      asset = _availableIcons[Math.floor(Math.random() * _availableIcons.length)]
      if (data.asset) asset = data.asset
    }

    let { logoName, brandSlogan, selectedLanguage } = this.props.newLogo.userPrefs
    let { layoutProcedure, brandTypeface, sloganTypeface } = data
    let logoParams = {
      logoName,
      brandSlogan,
      brandTypeface,
      sloganTypeface,
      asset,
      colorPalette: currentColorPalette,
      layoutProcedureParams: layoutProcedure.params,
      layoutProcedureName: layoutProcedure.name,
    }

    return (
          <LogoCanvas
             id={ "logo-canvas" + currentLogoPreview }
             uid={ currentLogoPreview }
             logoParams={ logoParams }
             selectedLanguage={ selectedLanguage }
             updateLogoCanvas={ this.props.updateLogoCanvas }
             editedParams={ this.state.editedParams }
             availableLogoPreviews={ this.props.newLogo.availableLogoPreviews }
          />
    )
  }

  renderLogoEditor(currentLogoPreview, selectedPreview, currentCover) {
    let { availableLogoPreviews, availableIcons, availableColorPalettes, availableTypefaces } = this.props.newLogo

    if (!availableLogoPreviews) return
    if (!availableLogoPreviews.payload) return
    let logoPreviews = availableLogoPreviews.payload
    if (logoPreviews.length < currentLogoPreview) return
    let data = logoPreviews[currentLogoPreview]
    if (!data) return

    let currentColorPalette = availableColorPalettes.find(color => color.uid === data.colorPalette.uid)

    let _availableIcons = []
    if (availableIcons) {
      if (availableIcons.payload) {
        if (availableIcons.payload.length) {
          _availableIcons = availableIcons.payload
        }
      }
    }
    let asset = null
    if ((data.layoutProcedure.name === 'generativeLayout005') ||
        (data.layoutProcedure.name === 'generativeLayout006') ||
        (data.layoutProcedure.name === 'generativeLayout0061') ||
        (data.layoutProcedure.name === 'generativeLayout009') ||
        (data.layoutProcedure.name === 'generativeLayout007')) {
      asset = _availableIcons[Math.floor(Math.random() * _availableIcons.length)]
      if (data.asset) asset = data.asset
    }

    let editedParams = this.state.editedParams[currentLogoPreview]
    // Change params that were edited sometime
    if (editedParams)
      Object.assign(data, editedParams)

    return (
          <LogoEditor
             selectedPreview={ selectedPreview }
             currentCover={ currentCover }
             rawSVG={data.svg}
             rawSVGDark={data.svgDark}
             canvas={data.canvas}
             canvasDark={data.canvasDark}
             uid={ currentLogoPreview }
             params={ data.layoutProcedure.params }
             text={ this.props.newLogo.userPrefs.logoName }
             sloganText={ this.props.newLogo.userPrefs.brandSlogan }
             colorPalette={ currentColorPalette }
             layoutProcedure={ data.layoutProcedure.name }
             brandTypeface={ data.brandTypeface }
             sloganTypeface={ data.sloganTypeface }
             updateLogoCanvas={ this.props.updateLogoCanvas }
             asset={ asset }
             availableIcons={ _availableIcons }
             availableColorPalettes={ availableColorPalettes }
             availableTypefaces={ availableTypefaces }
             selectedLanguage={ this.props.newLogo.userPrefs.selectedLanguage }
             onEditedParams={ this.onEditedParams.bind(this) }
          />
    )
  }

  renderLogoPreview() {
    let { selectedLanguage } = this.props.newLogo.userPrefs

    return (
          <LogoMockups
            selectedLanguage={ selectedLanguage }
            currentLogoPreview={ this.props.newLogo.currentLogoPreview }
          />
    )
  }

  onNextCover(evt) {
    if (!this.props.newLogo) return
    if (!this.props.newLogo.availableLogoPreviews) return
    if (!this.props.newLogo.availableLogoPreviews.payload) return
    let numberPreviews = this.props.newLogo.availableLogoPreviews.payload.length
    let currentIndex = this.props.newLogo.currentLogoPreview

    if (currentIndex < numberPreviews - 1) {
      this.props.getNextLogoPreview()
    }
    if (evt) evt.preventDefault()
  }

  onPrevCover(evt) {
    if (this.props.newLogo.currentLogoPreview > 0) {
      this.props.getPreviousLogoPreview()
    }
    if (evt) evt.preventDefault()
  }

  onEditedParams(param) {
    let { editedParams } = this.state
    let updatedParam = editedParams[this.props.newLogo.currentLogoPreview]
    if (updatedParam) {
      // If edited params already exist, assign the appropriate updated param
      Object.assign(updatedParam, param)
    } else {
      // Otherwise, initialize the edited params
      editedParams[this.props.newLogo.currentLogoPreview] = param
    }
    this.setState({ editedParams })
  }

  renderLogoCarousel() {
    let { availableLogoPreviews } = this.props.newLogo
    if (!availableLogoPreviews) return
    if (!availableLogoPreviews.payload) return
    let logoPreviews = availableLogoPreviews.payload
    let currentCover = this.props.newLogo.currentLogoPreview

    let logoPreviewsDivs = logoPreviews.map((logoPreview, index) => {
      let className
      if (index === currentCover-3) {
        className = "hideLeft"
      } else if (index === currentCover-2) {
        className = "prevLeftSecond"
      } else if (index === currentCover-1) {
        className = "prev"
      } else if (index === currentCover) {
        className = "selected"
      } else if (index === currentCover+1) {
        className = "next"
      } else if (index === currentCover+2) {
        className = "nextRightSecond"
      } else if (index === currentCover+3) {
        className = "hideRight"
      }

      if (className === "hideLeft" || className === "hideRight")
        return (
          <div key={ "carousel-item-" + index } className={ className + " carousel-item" }>
          </div>
        )
      if (className === "prevLeftSecond" || className === "prev")
        return (
          <div key={ "carousel-item-" + index } className={ className + " carousel-item" } onClick={ this.onPrevCover.bind(this) }>
            { (index >= 0) ? this.renderLogoCanvas(index) : null }
          </div>
        )
      if (className === "nextRightSecond" || className === "next")
        return (
          <div key={ "carousel-item-" + index } className={ className + " carousel-item" } onClick={ this.onNextCover.bind(this) }>
            { (index >= 0) ? this.renderLogoCanvas(index) : null }
          </div>
        )
      if (className === "selected")
        return (
          <div key={ "carousel-item-" + index } className={ className + " carousel-item" } onClick={ this.toggleEditor.bind(this) }>
            { (index >= 0) ? this.renderLogoCanvas(index, true) : null  }
          </div>
        )
      return null
    })

    return (
      <Swipeable
        onSwipedLeft={()=>this.onNextCover()}
        onSwipedRight={()=>this.onPrevCover()}>
          { logoPreviewsDivs }
      </Swipeable>
    )
  }

  toggleEditor(evt) {
    evt.preventDefault()
    this.setState({ displayLogoEditor: !this.state.displayLogoEditor })
  }

  togglePreview(evt) {
    evt.preventDefault()
    this.setState({ displayLogoPreview: !this.state.displayLogoPreview })
  }

  render() {
    let { selectedLanguage } = this.props.newLogo.userPrefs
    let currentCover = this.props.newLogo.currentLogoPreview

    // <a href="/toggle-editor" style={{ opacity: this.state.displayLogoPreview ? 0 : 1}} className={ this.state.displayLogoEditor ? "toggle-editor-dark" : "toggle-editor" } onClick={ this.toggleEditor.bind(this) }>
    //   { this.state.displayLogoEditor ? i18n[selectedLanguage]['hide-editor'] : i18n[selectedLanguage]['show-editor'] }
    // </a>
    // <a href="/preview-logos" className={ this.state.displayLogoPreview || this.state.displayLogoEditor ? "toggle-preview-dark" : "toggle-preview" } onClick={ this.togglePreview.bind(this) }>
    //   { this.state.displayLogoPreview ? i18n[selectedLanguage]['hide-preview'] : i18n[selectedLanguage]['show-preview'] }
    // </a>
    // <a href="mailto:contact@automagic.design" className="help-button">
    //   { i18n[selectedLanguage]['help-button'] }
    // </a>

    return (
      <div>
        <div className="preview-content">

          <div id="carousel-wrapper">
            <div id="carousel">
              { this.renderLogoCarousel() }
            </div>
          </div>
          <div className="preview-buttons">
            { this.renderLogoEditor(currentCover) }

            { /*
            <a href="/preview-logos" className={ this.state.displayLogoPreview ? "toggle-preview-dark" : "toggle-preview" } onClick={ this.togglePreview.bind(this) }>
              { this.state.displayLogoPreview ? i18n[selectedLanguage]['hide-preview'] : i18n[selectedLanguage]['show-preview'] }
            </a>
            */ }
          </div>

          <div className="preview-guide">
            { i18n[selectedLanguage]['preview-guide'] }
          </div>

          <CSSTransitionGroup
            transitionName="slide-up"
            transitionAppear={false}
            transitionAppearTimeout={500}
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}
            transitionEnter={true}
            transitionLeave={true}>

          { this.state.displayLogoPreview ? this.renderLogoPreview(currentCover) : null }

          </CSSTransitionGroup>

          <div className="help-button-wrapper">
            { selectedLanguage === 'pt'
            ?
              <div className="fb-customerchat">
                <MessengerChat
                  loggedInGreeting="Olá! Como posso te ajudar?"
                  loggedOutGreeting="Olá! Como posso te ajudar?"
                  language='pt_BR'
                />
              </div>
            : null
            }
          </div>

        </div>

      </div>
    )
  }
}

export default LogoPreview



// WEBPACK FOOTER //
// ./src/components/LogoPreview.js